export default __webpack_public_path__ + "static/media/claim-icon.264b1fda.svg";